import { connect } from "react-redux";
import { RootState } from "store/store";
import AppRegistrationInformation from "./AppRegistrationInformation";
import { getActiveEnvironmentMoniker } from "store/environments/environment-selectors";
import { setAppRegistrationInfoOpened } from "store/environments/environment-actions";

const mapStateToProps = (state: RootState) => {
    return {
        envMoniker: getActiveEnvironmentMoniker(state),
        isOpened: state.environmentsReducer.isAppRegistrationInfoOpened,
    };
};
const AppRegistrationInformationContainer = connect(mapStateToProps, {
    setAppRegistrationInfoOpened,
})(AppRegistrationInformation);

export default AppRegistrationInformationContainer;
